import { act } from "react";
import initialState from "../../../store/initialState";
import * as CapsVsDemandTable from "../services/CapacityvsDemandTableActionType";

const types = { ...CapsVsDemandTable };

const CapsVsDemandReducer = (
  state = initialState.CapsVsDemandReducer,
  action,
) => {
  switch (action.type) {
    //----------Capacity vs Demand dropdown Binding------//
    case types.FETCH_CAPACITY_REPORT_DDLIST_REQUEST:
      return { ...state, isCapacityDDListLoading: true };
    case types.FETCH_CAPACITY_REPORT_DDLIST_SUCCESS:
      return {
        ...state,
        isCapacityDDListLoading: false,
        capacityVsDemandData: action.payload?.values.reportsDDList || [],
      };
    case types.FETCH_CAPACITY_REPORT_DDLIST_FAILURE:
      return {
        ...state,
        isCapacityDDListLoading: false,
        capacityVsDemandData: [],
      };

    //--------Fetch Capacity vs Demand Table Data ------//
    case types.FETCH_CAPACITYVsDEMAND_REPORT_REQUEST:
      return { ...state, isReportLoading: true };
    case types.FETCH_CAPACITYVsDEMAND_REPORT_SUCCESS:
      return {
        ...state,
        isReportLoading: false,
        ReportData: action.payload?.values || [],
        totalrecords: action.payload?.recordsTotal,
      };
    case types.FETCH_CAPACITYVsDEMAND_REPORT_FAILURE:
      return {
        ...state,
        isReportLoading: false,
        ReportData: [],
      };

    //--------Fetch Available Shift Filter DDList-------//
    case types.FETCH_AVAILABLE_SHIFT_FILTERDDLIST_REQUEST:
      return { ...state, isFilterLoading: true };
    case types.FETCH_AVAILABLE_SHIFT_FILTERDDLIST_SUCCESS:
      return {
        ...state,
        isFilterLoading: false,
        FilterDDList: action.payload?.values || {},
      };
    case types.FETCH_AVAILABLE_SHIFT_FILTERDDLIST_FAILURE:
      return {
        ...state,
        isFilterLoading: false,
        FilterDDList: {},
      };

    //---------Fetch Legend Data------------//
    case types.FETCH_AVAILABLESHIFT_LEGEND_REQUEST:
      return { ...state, isLegendLoading: true };
    case types.FETCH_AVAILABLESHIFT_LEGEND_SUCCESS:
      return {
        ...state,
        isLegendLoading: false,
        LegendDDList: action.payload?.values || [],
      };
    case types.FETCH_AVAILABLESHIFT_LEGEND_FAILURE:
      return {
        ...state,
        isLegendLoading: false,
        LegendDDList: [],
      };

    //---------Available shift data loading-------//
    case types.FETCH_AVAILABLE_SHIFT_REQUEST:
      return { ...state, isShiftLoading: true };
    case types.FETCH_AVAILABLE_SHIFT_SUCCESS:
      return {
        ...state,
        isShiftLoading: false,
        ShiftData: action.payload?.values || [],
      };
    case types.FETCH_AVAILABLE_SHIFT_FAILURE:
      return { ...state, isShiftLoading: false, ShiftData: [] };

    //---------Available shift RPCE data loading-------//
    case types.FETCH_AVAILABLE_SHIFT_RPCE_REQUEST:
      return { ...state, isShiftRPCELoading: true };
    case types.FETCH_AVAILABLE_SHIFT_RPCE_SUCCESS:
      return {
        ...state,
        isShiftRPCELoading: false,
        RPCEData: action.payload?.values?.listAvailableShiftsRPCE || [],
        rpcetotalRecords: action.payload?.recordsTotal || 0,
      };
    case types.FETCH_AVAILABLE_SHIFT_RPCE_FAILURE:
      return { ...state, isShiftRPCELoading: false, RPCEData: [] };

    //--------Fetch Available Shift Worklist Data ------//
    case types.FETCH_AVAILABLE_WORKLISTDATA_REQUEST:
      return { ...state, isWorklistLoading: true };
    case types.FETCH_AVAILABLE_WORKLISTDATA_SUCCESS:
      return {
        ...state,
        isWorklistLoading: false,
        WorklistData: action.payload?.values?.listAvailableShifts || [],
        worklistTotalRecords: action.payload?.recordsTotal || 0,
      };
    case types.FETCH_AVAILABLE_WORKLISTDATA_FAILURE:
      return {
        ...state,
        isWorklistLoading: false,
        WorklistData: [],
      };

    //---------CapsVsDemand RPCE data loading-------//
    case types.FETCH_RPCE_DATA_CAPSVSDEMAND_REQUEST:
      return { ...state, iscapsVsDemandRPCELoading: true };
    case types.FETCH_RPCE_DATA_CAPSVSDEMAND_SUCCESS:
      return {
        ...state,
        iscapsVsDemandRPCELoading: false,
        CapsVsDemandRPCEDATA:
          action.payload?.values?.listCapacityVsDemandRPCE || [],
        capsVsDemandrpceTotalRecords: action.payload?.recordsTotal || 0,
      };
    case types.FETCH_RPCE_DATA_CAPSVSDEMAND_FAILURE:
      return {
        ...state,
        iscapsVsDemandRPCELoading: false,
        CapsVsDemandRPCEDATA: [],
      };

    //---------CapsVsDemand Worklist data loading-------//
    case types.FETCH_WORKLIST_DATA_CAPSVSDEMAND_REQUEST:
      return { ...state, iscapsVsDemandWorklistLoading: true };
    case types.FETCH_WORKLIST_DATA_CAPSVSDEMAND_SUCCESS:
      return {
        ...state,
        iscapsVsDemandWorklistLoading: false,
        CapsVsDemandWorklistData:
          action.payload?.values?.listCapacityVsDemand || [],
        capsVsDemandWorklistTotalRecords: action.payload?.recordsTotal || 0,
      };
    case types.FETCH_WORKLIST_DATA_CAPSVSDEMAND_FAILURE:
      return {
        ...state,
        iscapsVsDemandWorklistLoading: false,
        CapsVsDemandWorklistData: [],
      };

    //--------Delete Capacity vs Demand Report---//
    case types.DELETE_CAPSVSDEMAND_REPORT_REQUEST:
      return { ...state, isDeleteLoading: true };
    case types.DELETE_CAPSVSDEMAND_REPORT_SUCCESS:
      return { ...state, isDeleteLoading: false };
    case types.DELETE_CAPSVSDEMAND_REPORT_FAILURE:
      return { ...state, isDeleteLoading: false };

    //---------Fetch Capacity Hover Details Data------------//
    case types.FETCH_CAPACITY_HOVER_DETAILS_REQUEST:
      return { ...state, isCapacityDetailsLoading: true };
    case types.FETCH_CAPACITY_HOVER_DETAILS_SUCCESS:
      return {
        ...state,
        isCapacityDetailsLoading: false,
        CapacityDetailsData: action.payload?.values?.listQgendaDetails || [],
      };
    case types.FETCH_CAPACITY_HOVER_DETAILS_FAILURE:
      return {
        ...state,
        isCapacityDetailsLoading: false,
        CapacityDetailsData: [],
      };

    //---------Fetch Worklist Hover Details Data------------//
    case types.FETCH_WORKLIST_HOVER_DETAILS_REQUEST:
      return { ...state, isWorklistDetailsLoading: true };
    case types.FETCH_WORKLIST_HOVER_DETAILS_SUCCESS:
      return {
        ...state,
        isWorklistDetailsLoading: false,
        worklistDetailsData: action.payload?.values?.listQgendaDetails || [],
      };
    case types.FETCH_WORKLIST_HOVER_DETAILS_FAILURE:
      return {
        ...state,
        isWorklistDetailsLoading: false,
        worklistDetailsData: [],
      };

    //---------Fetch Capacity Vs Demand Get By Id Details------------//
    case types.FETCH_GETBY_ID_DETAILS_REQUEST:
      return { ...state, isGetByIdDetailsLoading: true };
    case types.FETCH_GETBY_ID_DETAILS_SUCCESS:
      return {
        ...state,
        isGetByIdDetailsLoading: false,
        getByIdDetailsData: action.payload?.values || [],
      };
    case types.FETCH_GETBY_ID_DETAILS_FAILURE:
      return {
        ...state,
        isGetByIdDetailsLoading: false,
        getByIdDetailsData: [],
      };

    //---------Fetch Notes Details------------//
    case types.FETCH_CAPSVSDEMAND_NOTES_DETAILS_REQUEST:
      return { ...state, isNotesLoading: true };
    case types.FETCH_CAPSVSDEMAND_NOTES_DETAILS_SUCCESS:
      return {
        ...state,
        isNotesLoading: false,
        notesDetailsData: action.payload?.values || [],
      };
    case types.FETCH_CAPSVSDEMAND_NOTES_DETAILS_FAILURE:
      return { ...state, isNotesLoading: false, notesDetailsData: [] };

    //---------Save Notes Details------------//
    case types.SAVE_CAPSVSDEMAND_NOTES_REQUEST:
      return { ...state, isNotesSaveLoading: true };
    case types.SAVE_CAPSVSDEMAND_NOTES_SUCCESS:
      return { ...state, isNotesSaveLoading: false };
    case types.SAVE_CAPSVSDEMAND_NOTES_FAILURE:
      return { ...state, isNotesSaveLoading: false };

    //---------Publish Capacity vs Demand Report---//
    case types.PUBLISH_CAPSVSDEMAND_REPORT_REQUEST:
      return {
        ...state,
        isPublishLoading: true,
        publishError: null,
        publishSuccess: false,
        publishResponse: null,
      };
    case types.PUBLISH_CAPSVSDEMAND_REPORT_SUCCESS:
      return {
        ...state,
        isPublishLoading: false,
        publishError: null,
        publishSuccess: true,
        publishMessage:
          action.payload?.resultMessage || action.payload?.Message || null,
        publishResponse: action.payload,
      };
    case types.PUBLISH_CAPSVSDEMAND_REPORT_FAILURE:
      return {
        ...state,
        isPublishLoading: false,
        publishError:
          action.error?.Message ||
          action.error ||
          "Failed to publish Capacity Vs Demand Report.",
        publishSuccess: false,
        publishResponse: null,
      };

    //--------Export data in Available Shift---//
    case types.EXPORT_RPCE_DATA_AVAILABLESHIFT_REQUEST:
      return { ...state, isExportLoading: true };
    case types.EXPORT_RPCE_DATA_AVAILABLESHIFT_SUCCESS:
      return { ...state, isExportLoading: false };
    case types.EXPORT_RPCE_DATA_AVAILABLESHIFT_FAILURE:
      return { ...state, isExportLoading: false };

    //--------Export data in Available Shift---//
    case types.EXPORT_WORKLIST_DATA_AVAILABLESHIFT_REQUEST:
      return { ...state, isExportLoading: true };
    case types.EXPORT_WORKLIST_DATA_AVAILABLESHIFT_SUCCESS:
      return { ...state, isExportLoading: false };
    case types.EXPORT_WORKLIST_DATA_AVAILABLESHIFT_FAILURE:
      return { ...state, isExportLoading: false };

    //--------Export data in Capacity vs Demand---//
    case types.EXPORT_RPCE_CAPSVSDEMAND_REQUEST:
      return { ...state, isExportLoading: true };
    case types.EXPORT_RPCE_CAPSVSDEMAND_SUCCESS:
      return { ...state, isExportLoading: false };
    case types.EXPORT_RPCE_CAPSVSDEMAND_FAILURE:
      return { ...state, isExportLoading: false };

    //--------Export data in Capacity vs Demand---//
    case types.EXPORT_WORKLIST_CAPSVSDEMAND_REQUEST:
      return { ...state, isExportLoading: true };
    case types.EXPORT_WORKLIST_CAPSVSDEMAND_SUCCESS:
      return { ...state, isExportLoading: false };
    case types.EXPORT_WORKLIST_CAPSVSDEMAND_FAILURE:
      return { ...state, isExportLoading: false };

    //--------Export Capacity vs Demand Report---//
    case types.EXPORT_CAPSVSDEMAND_REPORT_REQUEST:
      return { ...state, isExportLoading: true };
    case types.EXPORT_CAPSVSDEMAND_REPORT_SUCCESS:
      return { ...state, isExportLoading: false };
    case types.EXPORT_CAPSVSDEMAND_REPORT_FAILURE:
      return { ...state, isExportLoading: false };

    case types.UPDATE_DEMAND_TABLE_REDUCER:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export default CapsVsDemandReducer;
